import lazyScreen from '../utils/lazyScreen';
const MKGCampaign = lazyScreen(() => import('../pages/marketing/MKGCampaign/index.js'), 'pages/marketing/MKGCampaign/index.js');
const MessageChannelMonitor = lazyScreen(() => import('../pages/marketing/MessageChannelMonitor/index.js'), 'pages/marketing/MessageChannelMonitor/index.js');
const AdvertiseChannelMonitor = lazyScreen(() => import('../pages/marketing/AdvertiseChannelMonitor/index.js'), 'pages/marketing/AdvertiseChannelMonitor/index.js');
const ReviewChannelMonitor = lazyScreen(() => import('../pages/marketing/ReviewChannelMonitor/index.js'), 'pages/marketing/ReviewChannelMonitor/index.js');
const AffiliateChannelMonitor = lazyScreen(() => import('../pages/marketing/AffiliateChannelMonitor/index.js'), 'pages/marketing/AffiliateChannelMonitor/index.js');

export default [
    { path: '/marketing/ReviewChannelMonitor', component: ReviewChannelMonitor },
    { path: '/marketing/MKGReviews', component: ReviewChannelMonitor },
    { path: '/marketing/MKGCampaign/:code', component: MKGCampaign },
    { path: '/marketing/MessageChannelMonitor', component: MessageChannelMonitor },
    { path: '/marketing/MKGDeliveryLog', component: MessageChannelMonitor },
    { path: '/marketing/MKGOptOut', component: MessageChannelMonitor },
    { path: '/marketing/AdvertiseChannelMonitor', component: AdvertiseChannelMonitor },
    { path: '/marketing/MKGConversionEvent', component: AdvertiseChannelMonitor },
    { path: '/marketing/AffiliateChannelMonitor', component: AffiliateChannelMonitor },
    { path: '/marketing/MKGAffOffer', component: AffiliateChannelMonitor },
    { path: '/marketing/MKGAffPublisher', component: AffiliateChannelMonitor },
    { path: '/marketing/MKGAffTrackingLink', component: AffiliateChannelMonitor },
    { path: '/marketing/MKGAffPostback', component: AffiliateChannelMonitor }
];
